import { useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { MentorProfileContext } from 'src/mentor/context/MentorProfileContext'
import {
  AvailabilityPageContainer,
  PageHeadlineComponent,
  PageMainContentContainer,
} from '../MentorAvailabilityPage/MentorAvailabilityPageStyles'
import {
  ClinicItem,
  ClinicChoosingContainer,
} from '../MentorClinicBookingsPage/MentorClinicBookingStyles'
import { getAllRolesInBoolean } from 'src/mentor/layout/utils'
import { useDispatch } from 'react-redux'
import { fetchPrescriptionViewSettings } from 'src/clinic/reducers/prescription/services/prescriptionViewSettingsThunk'
import useClinicLocationsByBrand from './components/hooks/useClinicLocationsByBrand'
import {
  BrandSectionContainer,
  BrandHeader,
  ViewTemplatesButton,
} from './MentorPrescriptionTemplatesStyles'

export default function MentorPrescriptionTemplates() {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { mentorClinicAssociationData } = useContext(MentorProfileContext)

  const { clinicLocationOptions } = useClinicLocationsByBrand({
    mentorClinicAssociationData,
  })

  useEffect(() => {
    if (getAllRolesInBoolean().isDoctor) {
      dispatch(fetchPrescriptionViewSettings())
    }
  }, [])

  return (
    <AvailabilityPageContainer>
      <PageHeadlineComponent heading="Prescription Templates by Clinic" />
      <PageMainContentContainer>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
          {clinicLocationOptions?.map((brandGroup, brandIndex) => (
            <BrandSectionContainer key={brandIndex}>
              <BrandHeader>{brandGroup?.label}</BrandHeader>
              <ClinicChoosingContainer>
                {brandGroup?.options?.map((clinic, clinicIndex) => (
                  <ClinicItem key={clinicIndex} style={{ cursor: 'default' }}>
                    <div style={{ marginBottom: '24px', fontSize: '16px' }}>
                      <b>{clinic?.name || clinic?.title}</b>
                    </div>
                    <ViewTemplatesButton onClick={() => navigate(clinic?.id)}>
                      View Prescription Templates
                    </ViewTemplatesButton>
                  </ClinicItem>
                ))}
              </ClinicChoosingContainer>
            </BrandSectionContainer>
          ))}

          {/* Private Prescription Pad - Commented out as requested */}
          {/* <div>
            <div
              style={{
                fontSize: '20px',
                fontWeight: '600',
                marginBottom: '16px',
                color: '#1a1a1a',
                borderBottom: '2px solid #e0e0e0',
                paddingBottom: '8px',
              }}
            >
              Private
            </div>
            <ClinicChoosingContainer>
              <ClinicItem style={{ cursor: 'default' }}>
                <div style={{ marginBottom: '24px', fontSize: '16px' }}>
                  <b>Private Prescription Pad</b>
                </div>
                <div
                  onClick={() => navigate('private')}
                  style={{
                    cursor: 'pointer',
                    padding: '10px 16px',
                    borderRadius: '8px',
                    background: '#cbd3ff',
                    border: '1px solid #a2a8cc',
                    textAlign: 'center',
                    fontWeight: '500',
                    transition: 'all 0.2s ease',
                  }}
                >
                  View Templates
                </div>
              </ClinicItem>
            </ClinicChoosingContainer>
          </div> */}
        </div>
      </PageMainContentContainer>
    </AvailabilityPageContainer>
  )
}
